import { minHeight } from 'utils/minWidth';

export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const MILES_KM = 0.621371;

export const PAGESIZE = minHeight() ? 10 : 10;
